<div class="container">
  <div class="head">
    {{ 'MENU_EDIT.HEADER' | translate }}
  </div>
  <div class="tab-header">
    <a
      [routerLink]="['modifier-group']"
      routerLinkActive="active-tab"
      class="tab-link"
    >{{ 'MENU_EDIT.MODIFIER_GROUPS' | translate }}</a>
    <a
      [routerLink]="['promo']"
      routerLinkActive="active-tab"
      class="tab-link"
    >{{ 'MENU_EDIT.PROMO' | translate }}</a>
  </div>
  <div class="tab-content">
    <router-outlet></router-outlet>
  </div>
</div>
